
import {Component, Prop, PropSync, Vue, Watch} from 'vue-property-decorator';

@Component
export default class SbCreateRushDialog extends Vue {
  // Les props
  @Prop({default: 0}) private size!: number
  @PropSync('show', {default: false}) private isVisible!: boolean

  // Les propriétés
  private rushname: string = ''
  private loading: boolean = false

  // Les propriétés calculées
  // Les hooks
  // Les méthodes surveillées
  @Watch('isVisible')
  private onVisible() {
    if (this.isVisible) {
      this.rushname = ''
      this.loading = false
    }
  }

  // Les méthodes d'instance
  private onClick() {
    this.loading = true
    this.$emit('create', this.rushname)
  }
  // Les méthodes statiques
}
